import "./style/style.css";

export function GameInfo() {
  return (
    <section className="game-info-container">
      <div className="game-video">
        <div>
          <h1>The Game</h1>
          <h5>Experience the excitement, risk, and rewards!</h5>
        </div>

        <br />

        <br />

        <video muted autoPlay loop controls>
          <source src="/img/game-video.webm" type="video/webm" />
        </video>
      </div>
    </section>
  );
}
